const CartIconSvg = ({ width = 21, height = 22, stroke = 1, color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-1 -1 22 24"
    {...props}
  >
    <defs>
      <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="var(--color-primary)" />
        <stop offset="100%" stopColor="var(--color-primary)" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill={color || "var(--color-primary)"}
        stroke={color || "var(--color-primary)"}
        strokeWidth={stroke}
        fillRule="nonzero"
        d="M15.408 4.187h-.715a4.202 4.202 0 0 0-8.405 0h-.853a2.916 2.916 0 0 0-2.861 2.29L.07 17.64a2.93 2.93 0 0 0 2.861 3.573H17.91a2.932 2.932 0 0 0 2.861-3.573L18.269 6.477a2.915 2.915 0 0 0-2.862-2.29zM10.49.953a3.253 3.253 0 0 1 3.249 3.234H7.242A3.251 3.251 0 0 1 10.49.953zm8.964 18.564c-.374.47-.943.743-1.544.742H2.932a1.979 1.979 0 0 1-1.93-2.41L3.504 6.686a1.967 1.967 0 0 1 1.93-1.545h.853v2.294a.477.477 0 1 0 .954 0V5.141h6.499v2.294a.477.477 0 1 0 .954 0V5.141h.714a1.968 1.968 0 0 1 1.93 1.545L19.84 17.85c.133.586-.009 1.2-.386 1.668z"
      />
      <circle cx={10.5} cy={13.5} r={2.5} fill="url(#a)" />
    </g>
  </svg>
);

export default CartIconSvg;
